'use client';

import { FC } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { LeftNavMenuEntry } from './subcomponents/LeftNavMenuEntry';
import { RegularCompass, RegularPortfolio } from '../../../common/svgIcons';

export type TranslatedValuesLeftNavType = {
  portfolioText: string;
  discoverText: string;
};

const DesktopLeftNav: FC<{ translatedValues: TranslatedValuesLeftNavType }> = ({
  translatedValues,
}) => {
  const { discoverText, portfolioText } = translatedValues;

  return (
    <nav
      className={css({
        display: 'flex',
        flexDirection: 'column',
        fontSize: '12px',
        alignItems: 'center',
        position: 'fixed',
        top: '72px',
        insetInline: 0,
        bgColor: 'neutrals.card_fill_primary',
        height: 'calc(100vh - 72px)',
        width: '72px',
        py: '26px',
        paddingInline: 'extra_small_2',
        borderInlineEnd: '1px solid',
        borderInlineEndColor: 'neutrals.divider',
        gap: 'small',
      })}
    >
      <LeftNavMenuEntry
        url="/portfolio"
        icon={<RegularPortfolio color="neutrals.text_primary" />}
      >
        {portfolioText}
      </LeftNavMenuEntry>
      <LeftNavMenuEntry
        url="/discover"
        icon={<RegularCompass color="neutrals.text_primary" />}
      >
        {discoverText}
      </LeftNavMenuEntry>
    </nav>
  );
};

export { DesktopLeftNav };
